/* @flow */

import * as React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import Dashboard from '../dashboard/DashboardWrapper'
import BrandList from '../brands/BrandList'
import AgencyDashboard from '../agency/AgencyDashboard'
import { PermissionContext } from '../../infrastructure/components/Authorization'
import { UserIsAuthenticated, UserIsSetup } from '../auth'
import DomContainer from '../template/DomContainer'
import { Template } from '../template'
import { getPublicBrand } from '../shop/api'

class IndexModule extends React.Component<
  any,
  { isFetching: boolean, brand: Object }
> {
  state = {
    publicBrand: null,
    isFetching: true,
  }

  componentDidMount() {
    getPublicBrand().then(response => {
      if (response.status === 200) {
        this.setState({
          isFetching: false,
          publicBrand: response.payload.brand,
        })
      } else {
        this.setState({
          isFetching: false,
          publicBrand: null,
        })
      }
    })
  }

  render() {
    const { entity, isAuthenticated, ...restProps } = this.props
    const { publicBrand, isFetching } = this.state

    if (isFetching) {
      return null
    }

    const shouldDisplayWebshop =
      !isAuthenticated || entity.entity_type === 'shop'

    if (publicBrand !== null) {
      /**
       * For some brands, like Toms they have a public facing webshop. That means when visiting as an unauthenciated
       * user, we should just redirect to the webshop.
       *
       * Some other brands, like The Organic Company or Bondep, will have a custom domain (b2b.bondep.com). This means
       * their public brand will not be null, but their webshop is not public so the user should still be redirected
       * to the login screen.
       */
      const publicWebshopApp = publicBrand.apps.find(
        app => app.app === 'PublicWebshop'
      )
      const shouldDisplayWebshop =
        (publicWebshopApp !== undefined && !isAuthenticated) ||
        entity.entity_type === 'shop'

      if (publicWebshopApp) {
        return <Redirect to={`/shop/${publicBrand.id}`} />
      }
    }

    return <EnhancedIndexModuleForAuthenticated {...restProps} />
  }
}

export default connect(state => ({
  entity: state.session.entity,
  isAuthenticated: state.session.user.id !== undefined,
}))(IndexModule)

const IndexModuleForAuthenticated = props => {
  const isBrand = props.entityType === 'brand'

  if (props.entityType === 'brand') {
    return (
      <PermissionContext permission="dashboard">
        <Dashboard {...props} />
      </PermissionContext>
    )
  }

  if (props.entityType === 'shop') {
    return (
      <PermissionContext permission="brands:read">
        <BrandList {...props} />
      </PermissionContext>
    )
  }

  if (props.entityType === 'agency') {
    return (
      // TODO: add some permission context?
      <AgencyDashboard {...props} />
    )
  }

  return null
}

const IndexModuleForAuthenticatedWithRedux = connect(state => ({
  userRoles: state.session.user.roles,
  entityType: state.session.entity.entity_type,
}))(IndexModuleForAuthenticated)

const EnhancedIndexModuleForAuthenticated = UserIsAuthenticated(
  UserIsSetup(props => (
    <DomContainer {...props}>
      <Template {...props}>
        <IndexModuleForAuthenticatedWithRedux {...props} />
      </Template>
    </DomContainer>
  ))
)
